export enum FocusLevel {
  normal = 'Normal',
  focused = 'Focused',
  zen = 'Zen',
}
